// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"8a62fecd664bb50a","5303":"5d84783027f186b7"}[chunkId] + ".css";
};